import { render, staticRenderFns } from "./Blog1.vue?vue&type=template&id=2fa0ec1e&"
import script from "./Blog1.vue?vue&type=script&lang=js&"
export * from "./Blog1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports